import {Injectable} from "@angular/core";
import {DataResponse} from "src/app/models/http.models";
import { Observable } from "rxjs";
import {BaseApiService} from "./_baseApiService";
import {
  DocumentiArchivioDto,
  DocumentiArchivioGetListDocumentiTipoSezioneViewModel,
  DocumentiTipo,
  DocumentiTipoExtraInfoDetailList,
  DocumentiTipoSezione,
  FileDetailViewModel,
  FilePreviewViewModel,
  GetFilesViewModelPortas,
  GetFileTypesViewModel,
  UpdateExtraInfoViewModel
} from "../../models/documenti.models";

@Injectable()

export class DocumentService extends BaseApiService{
  public updateProfileImage(profileId : number,model : FormData):Observable<DataResponse<Response>>{
    return this.httpService.postFile(`PortalsFile/CambiaFotoProfilo?IdAnagraficaUtente=`+profileId,model);
  }
  public updateProfileCv(profileId : number,model : FormData):Observable<DataResponse<Response>>{
    return this.httpService.postFile(`PortalsFile/CaricaCvCandidato?IdAnagraficaUtente=`+profileId,model);
  }
  public getFilesTypes(model : GetFileTypesViewModel):Observable<DataResponse<DocumentiTipo>>{
    return this.httpService.post(`PortalsFile/GetFileTypes`,model);
  }
  public getListPaged (model : GetFilesViewModelPortas):Observable<DataResponse<DocumentiArchivioDto>>{
    return this.httpService.post(`PortalsFile/GetListPaged`,model);
  }
  public getSezioniList(profileId : number,model : DocumentiArchivioGetListDocumentiTipoSezioneViewModel):Observable<DataResponse<DocumentiTipoSezione>>{
    return this.httpService.post(`PortalsFile/GetFilesTipoSezione?IdAnagraficaUtente=`+profileId, model);
  }
  public getFilePreview(model : FilePreviewViewModel):Observable<any>{
    return this.httpService.getFilePost(`PortalsFile/FilePreview`,model);
  }
  public deleteDocument(model : FilePreviewViewModel):Observable<DataResponse<Response>>{
    return this.httpService.post(`PortalsFile/FileDelete`,model);
  }
  public fileArchive(model : FormData):Observable<DataResponse<Response>>{
    return this.httpService.postFile(`PortalsFile/FileArchive`,model);
  }
  public updateExtraInfo(model : UpdateExtraInfoViewModel):Observable<DataResponse<Response>>{
    return this.httpService.post(`PortalsFile/UpdateExtraInfo`,model);
  }
  public getFileDetail(model : FileDetailViewModel):Observable<DataResponse<DocumentiTipoExtraInfoDetailList>>{
    return this.httpService.post(`PortalsFile/FileDetail`,model);
  }

}
